<template>
  <span class="bih">
    <InfoHint :content="BESOIN_INTRO" placement="bottom" :inline="false" test-id="besoin-intro-info" />
  </span>
</template>

<script setup>
/**
 * LE « POURQUOI » DE L'ANALYSE DU BESOIN, RANGÉ DANS UN « i ».
 *
 * Il occupait un bandeau bleu en tête de la première section — 90 px de haut
 * pour une phrase que le commercial connaît par cœur dès le deuxième appel
 * (retour Figma « TUNNEL 1er appel MODIF »). Elle reste à portée, au survol ou
 * au clic sur l'icône posée à côté du titre.
 *
 * Un seul texte pour les deux écrans qui portent ce titre : la fenêtre
 * (`QuoteBesoinDialog`) et la page pleine page (`views/QuoteBesoinTunnel.vue`).
 */
import { InfoHint } from '../ui'

const BESOIN_INTRO =
  'Ce questionnaire vérifie que la formation demandée correspond aux attentes du client ' +
  'et identifie ses besoins spécifiques — dont la présence éventuelle de personnes en ' +
  'situation de handicap, comme l’exige Qualiopi.'
</script>

<style scoped>
/* L'icône du kit mesure 0,8 em de son parent : posée à côté d'un titre, elle
   prend la taille d'un texte courant, pas celle d'une note de bas de page. */
.bih {
  display: inline-flex;
  align-items: center;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-normal);
}
</style>
